export const INITIAL_STATE = {
  data: null,
  isFetching: false,
  error: false,
};

export const request = (state, action) => {
  return {
    ...state,
    isFetching: true,
  };
};

export const success = (state, action) => {
  return {
    ...state,
    data: action.data,
    isFetching: false,
    error: false,
  };
};

export const failure = (state, action) => {
  return {
    ...state,
    data: action.errData,
    isFetching: false,
    error: true,
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQ_MATCH_FINGERPRINT_REQUESTED":
      return request(state, action);
    case "REQ_MATCH_FINGERPRINT_SUCCEEDED":
      return success(state, action);
    case "REQ_MATCH_FINGERPRINT_FAILED":
      return failure(state, action);
    case "RESET_MATCH_FINGERPRINT":
      return INITIAL_STATE;
    default:
      return state;
  }
};
